/**
 * The global state selectors
 */

import { createSelector } from 'reselect';

const selectGlobal = state => state.get('global');

const selectRoute = state => state.get('route');

const makeSelectLocation = () =>
  createSelector(selectRoute, routeState => routeState.get('location').toJS());

const makeSelectAuthRedirect = () =>
  createSelector(makeSelectLocation(), location => location.authRedirect);

const makeSelectLocationState = () =>
  createSelector(
    makeSelectLocation(),
    selectLocation => (selectLocation.state ? selectLocation.state : undefined)
  );

const makeSelectLocationError = () =>
  createSelector(
    makeSelectLocationState(),
    state => (state && state.error ? state.error : undefined)
  );

const makeSelectCasinoSoundsOn = () =>
  createSelector(selectGlobal, globalState =>
    globalState.get('casinoSoundsOn')
  );

export {
  selectGlobal,
  makeSelectLocation,
  makeSelectAuthRedirect,
  makeSelectLocationError,
  makeSelectCasinoSoundsOn
};



// WEBPACK FOOTER //
// ./src/containers/App/selectors.js